var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck2258(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.2,
    height: 11.2,
    viewBox: "0 0 11.2 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(-188.4 -335.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5,10A5,5,0,1,0,0,5,5.015,5.015,0,0,0,5,10Z",
    transform: "translate(189 336)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,1.415,1.415,2.83,4.25,0",
    transform: "translate(191.875 339.585)",
    fill: "none",
    stroke: "#efb6b6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2258);
export default __webpack_public_path__ + "static/media/check2258.65fd685de07a97e85a917f8e36cb0f54.svg";
export { ForwardRef as ReactComponent };